// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { PFixMessage } from './PFixMessage';
export class GoogleAuthRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_ADD_2FA_REQUEST, fieldSet);
    }
    setUserId(userId) {
        this.FieldSet.SetField(FieldsFactory.FIELD_USER_ID, userId);
    }
}
